import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-annule-facture',
  templateUrl: './annule-facture.component.html',
  styleUrls: ['./annule-facture.component.scss']
})
export class AnnuleFactureComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterFactureByStatus('Annulé');
    }

}
